import React from 'react';
import { Line } from '@ant-design/plots';

const LineChart: React.FC<{
  configChart?: any;
}> = ({ configChart }) => <Line {...configChart} />;

export default LineChart;
